import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import FinishRechargeCreditComponent from "../../../components/Customer/credits/FinishRechargeCreditComponent";

const FinishRechargeCreditPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/');
    }

    return <FinishRechargeCreditComponent
        paymentId={ params.paymentId }
        shouldRedirect={ () => redirect() }
    />;
}

export default FinishRechargeCreditPage;
